export const classes = {
  dialog: 'w-[98vw] max-w-[500px] min-w-[150px]',
  body: 'w-full pt-2 pb-12 overflow-auto text-center text-grey-7',
  paragraph: 'my-2',
  boldParagraph: 'my-2 font-semibold',
};
